import React from 'react';
import { formatDateTimeMexico } from '../../utils/dateFormat';

const RedemptionTable = ({ items }) => {
  if (!items || items.length === 0) return null;
  return (
    <div className="overflow-x-auto rounded-2xl border border-gray-200">
      <table className="w-full min-w-[900px] text-sm">
        <thead className="bg-gray-50 sticky top-0 border-b border-gray-200">
          <tr>
            <th className="px-4 py-3 text-left text-gray-600 font-semibold">Cliente</th>
            <th className="px-4 py-3 text-left text-gray-600 font-semibold">Quién lo dio</th>
            <th className="px-4 py-3 text-left text-gray-600 font-semibold">Hora México</th>
            <th className="px-4 py-3 text-left text-gray-600 font-semibold">Entregado a</th>
            <th className="px-4 py-3 text-left text-gray-600 font-semibold">Beneficio</th>
            <th className="px-4 py-3 text-left text-gray-600 font-semibold">Tienda</th>
            <th className="px-4 py-3 text-left text-gray-600 font-semibold">Ticket</th>
            <th className="px-4 py-3 text-left text-gray-600 font-semibold">Estado</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {items.map((r) => (
            <tr key={r.id} className="hover:bg-gray-50 transition-colors">
              <td className="px-4 py-3">
                <div>
                  <div className="text-gray-900 font-medium">{r.user?.name ?? '-'}</div>
                  <div className="text-gray-500 text-xs">{r.user?.email ?? '-'}</div>
                  {r.user?.phone && <div className="text-gray-400 text-xs">{r.user.phone}</div>}
                  <div className="text-gray-400 text-xs">ID: {r.user?.id ?? '-'}</div>
                </div>
              </td>
              <td className="px-4 py-3 text-gray-600">
                {r.createdBy ? `${r.createdBy.name} (ID ${r.createdBy.id})` : '-'}
              </td>
              <td className="px-4 py-3 text-gray-600 whitespace-nowrap">
                {formatDateTimeMexico(r.createdAt)}
              </td>
              <td className="px-4 py-3 text-gray-600">{r.deliveredTo ?? '-'}</td>
              <td className="px-4 py-3 text-gray-900 font-medium">{r.benefit ?? '-'}</td>
              <td className="px-4 py-3 text-gray-600">{r.store?.name ?? '-'}</td>
              <td className="px-4 py-3 text-gray-900 font-semibold">{r.ticketNumber ?? '-'}</td>
              <td className="px-4 py-3 text-gray-500">{r.status ?? 'válida'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RedemptionTable;
